const TERMS_OF_USE_URL = 'https://pfsbc.com/legal-docs/terms-of-use';
const PRIVACY_POLICY_URL = 'https://pfsbc.com/legal-docs/privacy-policy';

export { PRIVACY_POLICY_URL, TERMS_OF_USE_URL };
